import CommonLayout from "./CommonLayout";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBlog } from "../../hooks/collections/useBlog";
import { IPost } from "../../@core/interfaces/IPost";
import { BlogForm } from "../AccountPage/BlogForm";

export const AccountCompanyPost = () => {
  const { postId } = useParams();
  const { getPost } = useBlog({ loadData: false });
  const [isLoading, setIsLoading] = useState(true);
  const [post, setPost] = useState<IPost>(null);

  const handleLoadPost = async () => {
    setPost(await getPost(postId))
    setIsLoading(false);
  }

  useEffect(() => {
    handleLoadPost()
  }, [postId]);

  return (
    <CommonLayout>
      <div className="space-y-6 sm:space-y-8">
        <div className="flex flex-col md:flex-row gap-5 items-center justify-between">
          <h2 className="text-3xl font-semibold">Post</h2>
        </div>

        {!isLoading && <BlogForm post={post}/>}
      </div>
    </CommonLayout>
  )
}
